import React, { useEffect, useState, useRef } from "react";
//import jpgImg from "../../../assets/user/images/1.jpg";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../utlis/user/routes.utlis";
import providerRoutes from "../../../utlis/provider/routes.utlis.js";
import { messaging } from "../../../firebase.js";
import { getToken } from "firebase/messaging";
//import { getToken, onMessage } from "firebase/messaging";
import { useJsApiLoader, StandaloneSearchBox } from "@react-google-maps/api";

import { VapidKey, GeolocationApiKey } from "../../../utlis/common.utlis.js";
import "../../../assets/css/home.css";
import mainImage from "../../../assets/images/main-img-1.png";
import mainImage2 from "../../../assets/images/main-img-2.jpg";
import searchArrow from "../../../assets/images/search-normal.svg";
import heroBgImage from "../../../assets/images/hero-arrow-1.webp";
import findJobsImg from "../../../assets/images/findjobs.svg";
import findCareImg from "../../../assets/images/findlocation.svg";
import findSearchImg from "../../../assets/images/findsearch.svg";
import appStoreImg from "../../../assets/images/app-store.png";
import playStoreImg from "../../../assets/images/play-store.png";
import appImg from "../../../assets/images/app-image.png";
import quoteIcon from "../../../assets/images/quote-2.svg";
import clientImg from "../../../assets/images/user.png";
import clientImg2 from "../../../assets/images/user-2.jpg";
import clientImg3 from "../../../assets/images/user-3.webp";

import Header from "../../common/Header.js";



const Home = () => {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [location, setLocation] = useState({
    lat: null,
    lng: null,
    address: null,
  });

  const requestPermission = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        const token = await getToken(messaging, {
          vapidKey: VapidKey,
        });
        console.log("FCM Token:", token);
        // const localData = {
        //   token: token,
        // };
        // localStorage.setItem("careexchange_fcm", JSON.stringify(localData));
      } else {
        // console.log("Permission denied");
      }
    } catch (error) {
      // console.error("Error requesting notification permission:", error);
    }
  };

  useEffect(() => {
    requestPermission();
  }, []);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GeolocationApiKey,
    libraries: ["places"],
  });

  const handlePlaceChange = () => {
    let [address] = inputRef.current.getPlaces();
    setLocation({
      lat: address.geometry.location.lat(),
      lng: address.geometry.location.lng(),
      address: address.formatted_address,
    });
    //setFieldValue("address", address.formatted_address);
  };

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent page reload
    localStorage.setItem("searchData", JSON.stringify(location));
    console.log("Search Location:", location);



    // commented on 13 nov 2025
    navigate(routes.login);
  };

  return (
    <>
      <Header></Header>

      <div className="main-wrapper" style={{ margin: 0, padding: 0 }}>
        <div className="care-form-section">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div className="care-form-image">
                  <div className="care-form-image-1">
                    <img decoding="async" src={mainImage} alt="" />
                  </div>
                  <div className="care-form-image-2">
                    <img decoding="async" src={mainImage2} alt="" />
                    <div className="circle upDown">
                      <svg width="111" height="111" viewBox="0 0 111 111" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.2" fillRule="evenodd" clipRule="evenodd" d="M110.785 60.6122L0.517544 60.6122C0.406443 59.4679 0.330326 58.31 0.302317 57.1451L111 57.1451C110.972 58.31 110.896 59.4679 110.785 60.6122ZM109.661 67.6711L1.6416 67.6711C1.38486 66.5272 1.16266 65.3689 0.975465 64.204L110.327 64.204C110.14 65.3689 109.918 66.5272 109.661 67.6711ZM107.545 74.7304L3.76465 74.7304C3.33425 73.5931 2.94589 72.4352 2.59905 71.2633L108.704 71.2633C108.364 72.4352 107.975 73.5931 107.545 74.7304ZM104.325 81.7892L6.98383 81.7892C6.36624 80.6589 5.79063 79.501 5.24913 78.3221L106.053 78.3221C105.519 79.501 104.936 80.6589 104.325 81.7892ZM99.7326 88.8551L11.5702 88.8551C10.7094 87.7317 9.89809 86.5809 9.13485 85.388L102.175 85.388C101.405 86.5809 100.593 87.7318 99.7326 88.8551ZM93.3218 95.9144L17.9809 95.9144C16.7873 94.8116 15.6427 93.6537 14.5536 92.4473L96.7492 92.4473C95.6601 93.6537 94.515 94.8116 93.3218 95.9144ZM83.8722 102.973L27.4236 102.973C25.6333 101.919 23.9131 100.761 22.2616 99.5061L89.0412 99.5062C87.3896 100.755 85.662 101.919 83.8722 102.973ZM64.2512 110.033C61.448 110.469 58.5757 110.698 55.6479 110.698C52.72 110.698 49.8478 110.469 47.0446 110.033C42.7224 109.36 38.5663 108.188 34.6321 106.565L76.6633 106.565C72.7294 108.188 68.5734 109.36 64.2512 110.033ZM0.517545 50.0858L110.785 50.0858C110.896 51.2302 110.972 52.3881 111 53.5529L0.302317 53.5529C0.330326 52.388 0.406444 51.2302 0.517545 50.0858ZM1.64862 43.02L109.654 43.02C109.918 44.1643 110.14 45.3222 110.327 46.4871L0.975467 46.4871C1.16266 45.3222 1.38487 44.1643 1.64862 43.02ZM3.76465 35.9611L107.538 35.9611C107.968 37.098 108.357 38.2564 108.704 39.4282L2.59905 39.4282C2.94589 38.2564 3.33425 37.098 3.76465 35.9611ZM6.99079 28.9018L104.318 28.9018C104.936 30.0322 105.512 31.19 106.046 32.3689L5.25614 32.3689C5.79064 31.19 6.37319 30.0322 6.99079 28.9018ZM11.5702 21.843L99.7326 21.843C100.593 22.9663 101.405 24.1172 102.175 25.3101L9.13486 25.3101C9.89809 24.1172 10.7094 22.9663 11.5702 21.843ZM17.981 14.7837L93.3218 14.7837C94.515 15.8795 95.6601 17.0443 96.7492 18.2508L14.5536 18.2508C15.6427 17.0443 16.7873 15.8794 17.981 14.7837ZM27.4236 7.71783L83.8722 7.71783C85.662 8.77907 87.3826 9.93693 89.0342 11.1849L22.2686 11.1849C23.9132 9.92992 25.6333 8.77906 27.4236 7.71783ZM47.0861 0.658978C49.8753 0.221974 52.7336 0.000198036 55.6479 0.00019829C58.5617 0.000198545 61.4205 0.221975 64.2097 0.65898C68.5459 1.3313 72.7154 2.50319 76.6563 4.12609L34.6391 4.12608C38.5799 2.50319 42.7499 1.33129 47.0861 0.658978Z" fill="#185EC8"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="care-provider-form-card">
                  <h2>Search For Care & Jobs Near You</h2>
                  <div className="care-provider-media"></div>
                  <div className="care-provider-form">
                    <form onSubmit={handleSubmit}>
                      <div className="form-group" style={{ marginBottom: 0 }}>
                        {/* <label>Your Location</label> */}
                        <div className="search-input-box">
                          {isLoaded && (
                            <StandaloneSearchBox
                              onLoad={(ref) =>
                                (inputRef.current = ref)
                              }
                              onPlacesChanged={() =>
                                handlePlaceChange()
                              }
                            >
                              <input
                                className="form-control"
                                placeholder="Enter Service Area"
                                defaultValue={location.address}
                                required
                              />
                            </StandaloneSearchBox>
                          )}
                          {/* <input type="text" name="" placeholder="Enter your Location" className="form-control" /> */}
                          <span className="search-location-icon"><img src={searchArrow} alt="" /></span>
                        </div>

                      </div>
                      <div className="form-group">
                        <p className="exampletext">Ex. Atlanta, GA 30317</p>
                      </div>
                      <div className="care-provider-action">
                        <div className="form-group">
                          <input type="submit" className="search-btn" value="Search Now" />
                        </div>
                        <div className="hero-section__arrow" style={{ backgroundImage: 'url(' + heroBgImage + ')' }}></div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="care-provider-section">
          <div className="container">
            <h1>Find Caregivers, Jobs, and quality Care Providers in your area</h1>
            <div className="row">
              <div className="col-md-4">
                <div className="home-findcare-card">
                  <div className="heading-title"><h2><Link to={routes.findCareHomeAss}>Find Care</Link></h2></div>
                  <div className="home-findcare-card-content">
                    <div className="findcare-card-icon">
                      <img src={findCareImg} alt="Find Care" />
                    </div>
                    <p>Caregivers, Home Care, In-Home Nursing, Adult Day Care and More! <span>CareExchange is here to help you find the ideal care provider for your needs.</span></p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="home-findcare-card">
                  <div className="heading-title"><h2><Link to={routes.careNetwork}>Find Jobs or Post your Resume</Link></h2></div>
                  <div className="home-findcare-card-content">
                    <div className="findcare-card-icon">
                      <img src={findJobsImg} alt="Find a job" />
                    </div>
                    <p>CareExchange helps people get jobs faster. Join our Care Staff Registry and access information on job openings by Employers/Care Providers Seeking the right candidates.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="home-findcare-card">
                  <div className="heading-title"><h2><Link to={routes.addPost}>Post a Job</Link></h2></div>
                  <div className="home-findcare-card-content">
                    <div className="findcare-card-icon">
                      <img src={findSearchImg} alt="Search Options" />
                    </div>
                    <p>Post your job opportunities here and connect with quality job applicants.</p>
                  </div>
                </div>
              </div>

            </div>
            <div className="text-center">
              <Link className="btnPost" to={providerRoutes.routes.providerRegister}>
                Join Care Providers Network to connect with people seeking Care Services for their loved ones.
              </Link>
            </div>
          </div>
        </div >

        <div className="care-app-section">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="care-app-card">
                  <h2>Care-Exchange – Find Trusted Care for Your Loved Ones</h2>
                  <p>Care-Exchange helps families find reliable, professional care for elderly loved ones. Whether you need a nurse, caregiver, or in-home support, our app makes it easy to connect with qualified providers—fast.</p>
                  <div className="care-app-action">
                    <a href="https://apps.apple.com/us/app/care-exchange/id6743622010" className="btn-app" title="App Store" target="_blank">
                      <img src={appStoreImg} alt="App Store" />
                    </a>
                    <a href="/" className="btn-app" title="Play Store" target="_blank">
                      <img src={playStoreImg} alt="App Store" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="care-app-media">
                  <img src={appImg} alt="CareExchange App" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="care-testi-section">
          <div className="container">
            <h1>Our Reviews</h1>
            <div className="row">
              <div className="col-md-4">
                <div className="testi-single-box">
                  <div className="testi-icon">
                    <img src={quoteIcon} alt="" />
                  </div>
                  <div className="testi-content">
                    <p className="testi-text">Care-Exchange has been a lifesaver for our family. Finding reliable and professional care for our elderly loved one was overwhelming, but their platform made the process so much easier. Highly recommend!</p>
                    <div className="testi-author">
                      <img src={clientImg} alt="Jason L." />
                    </div>
                    <h3 className="testi-title">Jason L.</h3>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="testi-single-box">
                  <div className="testi-icon">
                    <img src={quoteIcon} alt="" />
                  </div>
                  <div className="testi-content">
                    <p className="testi-text">We were struggling to find the right caregiver for my father until we found Care-Exchange. Their service connected us with kind, skilled professionals who truly care. The support we received was outstanding, and it gave us the reassurance we needed. </p>
                    <div className="testi-author">
                      <img src={clientImg2} alt="Sheri M." />
                    </div>
                    <h3 className="testi-title">Sheri M.</h3>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="testi-single-box">
                  <div className="testi-icon">
                    <img src={quoteIcon} alt="" />
                  </div>
                  <div className="testi-content">
                    <p className="testi-text">Care-Exchange made finding senior care stress-free. The caregivers are well-vetted, and the platform is easy to use. We found a perfect match for my grandmother, and she’s never been happier!</p>
                    <div className="testi-author">
                      <img src={clientImg3} alt="Laura V." />
                    </div>
                    <h3 className="testi-title">Laura V.</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className="care-provider-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="care-provider-copyright">
                <p>&copy; 2025 Care-Exchange.com. All rights reserved.</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="care-provider-copyright text-end">
                <Link className="" to={routes.about}>
                  About Us
                </Link> &nbsp; | &nbsp;
                <Link className="" to={routes.contact}>
                  Contact Us
                </Link> &nbsp; | &nbsp;
                <Link className="" to={routes.term}>
                  Terms and Conditions
                </Link> &nbsp; | &nbsp;
                <Link className="" to={routes.privacy}>
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 
      <div className="auth-section auth-height">
        <div className="auth-bg-video">
          <img id="background-video" src={jpgImg} />
        </div>
        <div className="auth-content-card">
          <div className="container">
            <div className="auth-card">
              <div className="row">
                <div className="col-md-6">
                  <div className="auth-content">
                    <div className="auth-content-info">
                      <h2>112</h2>
                      <p>families seeking care near you</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 auth-form-info">
                  <div className="auth-form">
                    <div className="brand-logo">
                      <img src={Logo} alt="logo" />
                    </div>
                    <h4>
                      Helping you find your ideal care Provider in your area
                    </h4>

                    <div className="auth-form-action">
                      <Link className="auth-gr-btn" to={routes.login}>
                        Login
                      </Link>
                      <Link className="auth-bl-btn" to={routes.signup}>
                        Sign Up
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       */}
    </>
  );
};

export default Home;
